import { useEffect } from "react";
import { usePageLoadingState } from "../contexts/page-loading.context";
import { LoadingIndicator } from "./LoadingIndicator";

export function NavLoadingIcon() {
  const { loading, registerNav } = usePageLoadingState();
  useEffect(registerNav, [registerNav]);
  return (
    <span
      data-page-loading={loading}
      aria-busy={loading}
      style={{
        display: "inline-flex",
        alignItems: "center",
        width: 61,
        height: 28,
        marginLeft: 8,
        marginRight: 8,
      }}
    >
      <LoadingIndicator
        navigation
        active={loading}
        size={28}
        aria-label={loading ? "Loading page" : "Bubble"}
      />
    </span>
  );
}
